import {
  DeleteOutlined,
  EditOutlined,
  MinusCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Checkbox, Col, Form, Row, Space } from "antd";
import ButtonComponent from "components/ButtonComponent";
import DrawerComponent from "components/DrawerComponent";
import TableComponent from "components/TableComponent";
import TableConfig from "components/TableConfig";
import BasicCrud from "components/crud/BasicCrud";
import FormComponent from "components/form/FormComponent";
import InputCheckbox from "components/form/InputCheckbox";
import InputSelect from "components/form/InputSelect";
import InputText from "components/form/InputText";
import InputTextarea from "components/form/InputTextarea";
import useFormHook from "hooks/useFormHook";
import React, { useEffect, useState } from "react";
import { Operations } from "utils/constants";
import InputDate from "components/form/InputDate";
import NewFormComponent from "components/form/NewFormComponent";
import PurchseOrder from "components/form/PurchaseOrder";
import PopDelete from "components/popup/PopDelete";
import { getDepartmentAccordingBranch } from "utils/functions";

const initialValues = {
  OperationId: 1,
  Id: null,
  ReferenceNo: null,
  TransactionTypeId: null,
  DemandOrderId: null,
  TransactionDate: null,
  TransactionNo: "",
  SupplierId: null,
  DepartmentId: null,
  ToDepartmentId: null,
  BranchId: null,
  UserId: 1,
  Gross: 0,
  Tax: 0,
  Discount: 0,
  Amount: 0,
  TimeStamp: "",
  Enabled: 1,
  Deleted: 0,
  CompanyId: 0,
  IsSubmit: false,
  TransType: "PURCHASE_ORDER",
  TransactionDetail: [],
};

export default function PurchaseOrder() {
  const {
    firstFieldRef,
    tempRows,
    isLoading,
    isTableLoading,
    handleDelete,
    handleDrawer,
    handleEdit,
    handleOpeningInventoryEdit,
    handleSearch,
    handleSubmit,
    handleOpeningInventorySubmit,
    handleAdd,
    handleSubmitAll,
    open,
    add,
    formData,
    search,
    dataSet,
    transformOptions,
    inputRef,
    itemCodeRefs,
    quantityRefs,
  } = useFormHook("GRN", initialValues);
  const { getColumnSearchProps, sort, sortString } = TableConfig();
  const [filteredDepartments, setFilteredDepartments] = useState(
    transformOptions(dataSet?.Table2)
  );
  const [drawerTableData, setDrawerTableData] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  console.log('checking form values ', formValues)

  const columns = [
    {
      key: "1",
      title: "PO Date",
      dataIndex: "PODate",
    },
    {
      key: "2",
      title: "PO Number",
      dataIndex: "PO Number",
    },
    {
      key: "3",
      title: "Vendor",
      dataIndex: "Vendor",
    },
    {
      key: "4",
      title: "Branch",
      dataIndex: "Branch",
    },
    {
      key: "5",
      title: "Department",
      dataIndex: "Department",
    },
    {
      key: "6",
      title: "IsSubmit",
      dataIndex: "IsSubmit",
    },
    {
      key: "10",
      title: "Action",
      className: "text-center",
      render: (_, record) => (
        <Space>
          {" "}
          <ButtonComponent
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          />{" "}
          <ButtonComponent
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record)}
            danger={true}
          />{" "}
        </Space>
      ),
    },
  ];

  const drawerTableColumns = [
    {
      key: "1",
      title: "Item Code",
      dataIndex: "ItemCode",
      ...getColumnSearchProps("ItemCode"),
    },
    {
      key: "4",
      title: "Item Name",
      dataIndex: "ItemName",
      ...getColumnSearchProps("ItemName"),
    },
    {
      key: "2",
      title: "Category",
      dataIndex: "CategoryName",
      ...getColumnSearchProps("CategoryName"),
    },
    {
      key: "3",
      title: "Sub Category",
      dataIndex: "SubCategoryName",
      ...getColumnSearchProps("SubCategoryName"),
    },
    {
      key: "3",
      title: "Issuance Unit",
      dataIndex: "IssuanceUnit",
      ...getColumnSearchProps("IssuanceUnit"),
    },
    {
      key: "6",
      title: "Quantity",
      dataIndex: "Quantity",
      render: (_, record, index) => {
        return (
          <InputText
            type="number"
            value={record.Quantity}
            ref={(el) => (quantityRefs.current[index] = el)}
            onChange={(e) => handleQuantityChange(e, index)}
            onKeyPress={(e) => handleQuantityKeyPress(e, e.target.value, index)}
          />
        );
      },
    },
    {
      key: "7",
      title: "Rate",
      dataIndex: "Rate",
      render: (_, record, index) => {
        return (
          <InputText
            type="number"
            value={record.Rate}
            ref={(el) => (quantityRefs.current[index] = el)}
            onChange={(e) => handleRateChange(e, index)}
            onKeyPress={(e) => handleQuantityKeyPress(e, e.target.value, index)}
          />
        );
      },
    },
    {
      key: "8",
      title: "Action",
      render: (_, record) => (
        <Space>
          {" "}
          <PopDelete handleDelete={() => {}}>
            <ButtonComponent
              icon={<MinusCircleOutlined />}
              danger={true}
              type={"dashed"}
            />{" "}
          </PopDelete>
        </Space>
      ),
    },
  ];

  const searchFields = (
    <>
      <Row gutter={[20, 0]}>
        <Col xs={24} md={12} xl={8}>
          <InputText label={"PO Number"} name={"PONumber"} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputDate label={"PO Date"} name={"ShortName"} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputSelect label={"Vendor"} name={"HeadOffice"} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputSelect label={"Branch"} name={"Enabled"} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputSelect label={"Department Name"} name={"Name"} />
        </Col>
        {/* <Col xs={24} md={12} xl={8}>
          <InputSelect label={"Items"} name={"ShortName"} />
        </Col> */}
        {/* <Col xs={24} md={12} xl={8}>
          <InputText label={"Demand Qty"} name={"Name"} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputText label={"Rate"} name={"ShortName"} />
        </Col> */}
      </Row>
    </>
  );
  const formFields = (
    <>
      <Row gutter={[20, 0]}>
        <Col xs={24} md={12} xl={8}>
          <InputText label={"PO Number"} name={"Name"} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputDate label={"PO Date"} name={"PODate"} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputSelect label={"Supplier"} name={"Supplier"} options={transformOptions(dataSet?.Table12)}/>
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputSelect
            label={"Branch"}
            name={"BranchName"}
            options={transformOptions(dataSet?.Table2)}
            onChange={(value) => {
              if (value) {
                // Filter departments based on selected branch
                const departments = getDepartmentAccordingBranch(
                  dataSet?.Table3,
                  value
                );
                setFilteredDepartments(transformOptions(departments));
              } else {
                setFilteredDepartments(transformOptions(dataSet?.Table2));
              }
            }}
          />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputSelect
            label={"Department"}
            name={"DepartmentName"}
            options={filteredDepartments}
          />
        </Col>
        {/* <Col xs={24} md={12} xl={8}>
          <InputSelect label={"Items"} name={"ShortName"} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputText label={"Demand Qty"} name={"Name"} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputText label={"Rate"} name={"ShortName"} />
        </Col> */}
        {/* <Col xs={24} md={12} xl={8}>
          <InputTextarea label={"Description"} name={"Name"} />
        </Col> */}
      </Row>
    </>
  );

  const handleQuantityChange = (quantity, index) => {
    setDrawerTableData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = {
        ...updatedData[index],
        Quantity: quantity,
      };
      return updatedData;
    });
  };

  const handleRateChange = (rate, index) => {
    setDrawerTableData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = {
        ...updatedData[index],
        Rate: rate,
      };
      return updatedData;
    });
  };

  const handleQuantityKeyPress = (e, itemCode, index) => {
    if (e.key === "Enter") {
      e.preventDefault();
      // Move focus to the next row's item code
      const nextIndex = index + 1;
      if (quantityRefs.current[nextIndex]) {
        quantityRefs.current[nextIndex].focus();
      }
    }
  };

  const getTransactionDetail = (data) => {
    return data.map((item) => ({
      ItemId: item.ItemId,
      UnitId: item.IssuanceUnitId, // Assuming this is the intended field
      Quantity: Number(item.Quantity),
      Rate: Number(item.Rate),
    }));
  };
  

  return (
    // <Card>
    // <BasicCrud
    //   formTitle="Purchase Order"
    //   tableTitle="Purchase Order"
    //   searchFields={searchFields}
    //   formFields={formFields}
    //   handleSubmit={handleSubmit}
    //   handleSearch={handleSearch}
    //   addFormInstance={addFormInstance}
    //   searchFormInstance={searchFormInstance}
    //   extra={"add"}
    //   rows={rows}
    //   columns={columns}
    //   handleDrawer={handleDrawer}
    //   isDrawerOpen={isDrawerOpen}
    //   isFormLoading={isFormLoading}
    //   isTableLoading={isTableLoading}
    // />
    <>
      <FormComponent
        title={"Search Purchase Order"}
        children={searchFields}
        handleSubmit={handleSearch}
        form={search}
        submit={"Search"}
        isLoading={isLoading}
        initialValues={initialValues}
        extra={
          <ButtonComponent
            icon={<EditOutlined />}
            text={"Add"}
            size={"small"}
            onClick={() => handleDrawer(Operations.Insert)}
          />
        }
        // customAction={customAction}
      />
      <br />
      <TableComponent
        columns={columns || []}
        rows={dataSet?.Table1 || []}
        title={"Purchase Order List"}
        loading={isTableLoading}
      />
      <DrawerComponent
        onClose={() => {
          setDrawerTableData([]);
          handleDrawer(Operations.Select);
        }}
        open={open}
        width={1000}
        extra={
          <Space>
            <ButtonComponent
              icon={<EditOutlined />}
              text={"Save"}
              size={"medium"}
              onClick={() => {
                const TransactionDetail = getTransactionDetail(drawerTableData);
                const Id = formValues?.Id || null;
                handleOpeningInventorySubmit({
                  DepartmentId: formValues.DepartmentName,
                  BranchId: null,
                  TransactionDate: formValues.TransactionDate,
                  SupplierId: formValues.Supplier,
                  TransactionDetail,
                  OperationId: isEdit ? 3 : 2,
                  IsSubmit: false,
                });
                setDrawerTableData([]);
                setFormValues({});
                // setIsEdit(false);
              }}
            />
            <ButtonComponent
              icon={<SaveOutlined />}
              text={"Submit"}
              size={"medium"}
              onClick={() => {
                // const TransactionDetail = getTransactionDetail(drawerTableData);
                // const Id = formValues?.Id || null;
                // handleOpeningInventorySubmit({
                //   DepartmentId: formValues.DepartmentName,
                //   BranchId: null,
                //   TransactionDate: formValues.TransactionDate,
                //   Id: Id,
                //   TransactionDetail,
                //   OperationId: isEdit ? 3 : 2,
                //   IsSubmit: true,
                // });
                // setDrawerTableData([]);
                // setFormValues({});
                // setIsEdit(false);
              }}
            />
          </Space>
        }
      >
        <NewFormComponent
          children={formFields}
          handleSubmit={handleSubmit}
          form={add}
          submit={
            formData?.OperationId == Operations.Update ? "Update" : "Save"
          }
          isLoading={isLoading}
          initialValues={initialValues}
          setFormValues={setFormValues}
        />
        <PurchseOrder
          dataSet={dataSet}
          setDrawerTableData={setDrawerTableData}
          drawerTableData={drawerTableData}
          title="Create Purchase Order"
        />
        <TableComponent
          columns={drawerTableColumns || []}
          rows={drawerTableData || []}
          title={"Purchase Order List"}
          loading={isTableLoading}
        />
      </DrawerComponent>
    </>
    // </Card>
  );
}
